// API
import { replace } from "react-router-redux";
import { post } from "../../../services/api";
// Router
import { BASE_URL } from "../../../config/constants";
// Ducks
import { hideSpinner, showSpinner } from "../../../services/spinner.ducks";
import {
  setErrorNotification,
  setNotification
} from "../../../components/SmartNotification/SmartNotification.ducks";
import { clearMissingExamsParts } from "../Exams/Exams.ducks";

const SET_ERROR = "SET_ERROR";
const RESET_BOOKING_STATE = "RESET_BOOKING_STATE";

const defaultState = {
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return { ...state, error: action.payload };
    case RESET_BOOKING_STATE: {
      return defaultState;
    }
    default:
      return state;
  }
};

const setError = (value) => ({
  type: SET_ERROR,
  payload: value
});

export const resetBookingState = () => ({
  type: RESET_BOOKING_STATE
});

export const initPayment = (...paymentData) => async (dispatch) => {
  const newPaymentData = paymentData;

  try {
    dispatch(showSpinner());
    const { data } = await dispatch(post("/payment/init", paymentData));

    dispatch(setError(null));

    if (data) {
      if (data.success) {
        newPaymentData[0].globalTransactionId = data.resultContext.globalTransactionId;

        await dispatch(post("/payment/booking", newPaymentData));
      }
      dispatch(hideSpinner());
      return data;
    }

    dispatch(hideSpinner());

    dispatch(
      setErrorNotification({
        messageTranslationKey:
          "modules.localization.register.anonymous.smartNotifications.error.generic",
        titleTranslationKey:
          "modules.localization.register.anonymous.smartNotifications.error.error"
      })
    );
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      dispatch(
        setErrorNotification({
          messageTranslationKey:
            error.response.data.message ||
            "modules.localization.register.anonymous.smartNotifications.error.generic",
          titleTranslationKey:
            "modules.localization.register.anonymous.smartNotifications.error.error"
        })
      );
    } else {
      dispatch(setError("Server error"));
    }
    dispatch(hideSpinner());
  }
};

export const scheduleBooking = ({ missingExamParts, ...bookingData }) => async (
  dispatch,
  getState
) => {
  const {
    auth: { role },
    users: { selectedCandidate }
  } = getState();
  const isAdmin = role === "admin";
  let url = `/booking`;
  let redirectUrl = `${BASE_URL}/dashboard/bookings`;

  if (isAdmin) {
    bookingData.candidateId = selectedCandidate.id;
    url = `/admin/booking`;
    redirectUrl = `${BASE_URL}/dashboard/bookings`;
  }

  try {
    dispatch(showSpinner());

    const { data } = await dispatch(post(url, bookingData));

    dispatch(setError(null));
    dispatch(replace(redirectUrl));
    dispatch(hideSpinner());

    if (data.issuedRefundVoucher) {
      dispatch(
        setNotification({
          confirmAction: () => {
            dispatch(replace(`${BASE_URL}/dashboard/vouchers`));
          },
          confirmLabel:
            "modules.localization.register.authenticated.smartNotifications.label.viewVouchers",
          messageTranslationKey:
            "modules.localization.register.authenticated.smartNotifications.label.newVoucherEmitted",
          titleTranslationKey:
            "modules.localization.register.authenticated.smartNotifications.label.newVoucher",
          type: "info"
        })
      );
    }

    if (missingExamParts) {
      dispatch(
        setNotification({
          confirmAction: () => {
            dispatch(replace(`${BASE_URL}/dashboard`));
          },
          cancelAction: () => {
            dispatch(clearMissingExamsParts());
          },
          confirmLabel: "modules.localization.register.authenticated.smartNotifications.label.book",
          messageTranslationKey:
            "modules.localization.register.authenticated.smartNotifications.label.missingExaminationParts",
          titleTranslationKey:
            "modules.localization.register.authenticated.smartNotifications.label.bookMissingParts",
          type: "info"
        })
      );
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      dispatch(
        setErrorNotification({
          messageTranslationKey:
            error.response.data.message ||
            "modules.localization.register.anonymous.smartNotifications.error.generic",
          titleTranslationKey:
            "modules.localization.register.anonymous.smartNotifications.error.error"
        })
      );
    } else {
      dispatch(setError("Server error"));
    }
    dispatch(hideSpinner());
  }
};
